export default Object.freeze({
  Submitted: 1,
  Recommendation: 13,
  Not_Recommendation: 11,
  PartialRecommendation: 27,
  RequirementsDoesNotAccomplish: 28,
  FundsSeparation: 30,
  DeliveredForObligation: 39,
});
